import { render, staticRenderFns } from "./passengerAppraise.vue?vue&type=template&id=ddf9d04c&scoped=true&"
import script from "./passengerAppraise.vue?vue&type=script&lang=js&"
export * from "./passengerAppraise.vue?vue&type=script&lang=js&"
import style0 from "./passengerAppraise.vue?vue&type=style&index=0&id=ddf9d04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9d04c",
  null
  
)

export default component.exports